export const PATIENT_REFILL_ROUTE = '/patient/refill' as const;
export const PATIENT_REFILL_PHARMACY_ROUTE = '/patient/refill-pharmacy' as const;
export const PATIENT_ORDERS_ROUTE = '/patient/orders' as const;
export const PATIENT_PRODUCT_DETAIL_PATH = '/patient/product-detail/' as const;
export const PATIENT_PRODUCT_DETAIL_ROUTE = '/patient/product-detail/:id' as const;
export const PATIENT_PAYMENT_SUCCESS_ROUTE = '/patient/payment-success' as const;
export const PRESCRIPTIONS_ROUTE = '/prescriptions' as const;
export const PRESCRIPTION_ROUTE = '/prescription/:id' as const;
export const PATIENT_CLICK_AND_COLLECT = '/patient/click-and-collect' as const;

export const ESCRIPT_ONBOARDING_ROUTE = '/onboarding' as const;
export const ESCRIPT_INVITE_EXPIRED_ROUTE = '/onboarding/invite-expired/:onBoardKey' as const;
export const ESCRIPT_REFILL_ROUTE = '/escript/refill' as const;
export const ESCRIPT_REFILL_PHARMACY_ROUTE = '/escript/refill-pharmacy' as const;
export const ESCRIPT_ORDERS_ROUTE = '/escript/orders' as const;
export const ESCRIPT_PRODUCT_DETAIL_PATH = '/escript/product-detail/' as const;
export const ESCRIPT_PRODUCT_DETAIL_ROUTE = '/escript/product-detail/:id' as const;
export const ESCRIPT_PAYMENT_SUCCESS_ROUTE = '/escript/payment-success' as const;

export const PROFILE_DETAILS_ROUTE = '/profile-detail' as const;

export const LOGIN_ROUTE = '/login' as const;
export const LOGIN_PATIENT_ONBOARDKEY_ROUTE = '/login/patient/:onBoardKey' as const;
export const LOGIN_ONBOARDKEY_ROUTE = '/login/:onBoardKey' as const;
export const LOGIN_PATIENT_ONBOARDKEY_PATH = '/login/patient/' as const;

export const LOGOUT_ROUTE = '/logout' as const;

export const FORGOT_PASSWORD_ROUTE = '/forgot-password' as const;
export const RESET_PASSWORD_LEGACY_ROUTE = '/reset-password/:id' as const;
export const RESET_PASSWORD_ROUTE = '/reset-password' as const;

export const PAYMENT_CONFIRM_ROUTE = '/payment-confirm' as const;
export const PAYMENT_SUCCESS_ROUTE = '/payment-success' as const;

export const PAY_BY_INVOICE_ROUTE = '/pay-by-invoice/:token' as const;

export const POLICY_ROUTE = '/policy' as const;

export const FAQ_ROUTE = '/faq' as const;

export const HEALTH_CHECK_ROUTE = '/health-check' as const;

export const HOME_ROUTE = '/home' as const;

const UMEDS_MARKETING_HOME = 'https://www.umeds.com.au';

export const UMEDS_MARKETING = {
  HOME: UMEDS_MARKETING_HOME,
  PRIVACY_POLICY: `${UMEDS_MARKETING_HOME}/privacy-policy`,
  TERMS_CONDITIONS: `${UMEDS_MARKETING_HOME}/terms-conditions`,
} as const;
